var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chat-page" } },
    [
      _c(
        "AppBreadCrumb",
        {
          key: Math.random(),
          attrs: {
            paths: [{ title: _vm.$t("message.CHAT"), path: "chat" }],
            select:
              !!_vm.activeConversation ||
              !["siteVisitors", 4].includes(_vm.tabIndex),
            "show-trial-remain-day": true,
          },
          on: { "to-chat-main": _vm.toMainMenu },
        },
        [
          _vm.tabIndex === "conversationHistory" && !_vm.activeConversation
            ? _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.timeSelect,
                      expression: "timeSelect",
                    },
                  ],
                  attrs: { id: "time-select" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.timeSelect = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.saveFilter,
                    ],
                  },
                },
                [
                  _c("option", { attrs: { value: "today" } }, [
                    _vm._v(_vm._s(_vm.$t("time.today"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "yesterday" } }, [
                    _vm._v(_vm._s(_vm.$t("time.yesterday"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-week" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("time.currentWeek")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-week" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "current-month" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("time.currentMonth")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-month" } }, [
                    _vm._v(_vm._s(_vm.$t("time.lastMonth"))),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "last-30" } }, [
                    _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.getLast11Months(), function (m, i) {
                    return _c(
                      "option",
                      { key: i, domProps: { value: m.date } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(m.name) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "custom" } }, [
                    _vm._v("Custom"),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex === "conversationHistory" && !_vm.activeConversation
            ? _c(
                "a-button",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { placement: "bottom" },
                      expression: "{ placement: 'bottom' }",
                    },
                  ],
                  staticClass:
                    "actionButton d-flex align-items-center classic-button ant-btn-reset",
                  attrs: {
                    size: "small",
                    content: _vm.$t("message.clearSelectedFiltersTooltip"),
                  },
                  on: { click: _vm.resetFilters },
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: { placement: "bottom" },
                          expression: "{ placement: 'bottom' }",
                        },
                      ],
                      staticStyle: { display: "block", "font-size": "12px" },
                      attrs: {
                        content: _vm.$t("message.clearSelectedFiltersTooltip"),
                      },
                    },
                    [
                      _c("span", { staticClass: "md-icon" }, [
                        _vm._v("delete_forever"),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex === "representative" && !_vm.activeConversation
            ? _c("div", { staticClass: "chatListSettingContainer" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "custom-checkbox2",
                    attrs: { content: _vm.$t("message.showOnlineAgents") },
                  },
                  [
                    _c(
                      "a-switch",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.showOnlineAgents,
                          callback: function ($$v) {
                            _vm.showOnlineAgents = $$v
                          },
                          expression: "showOnlineAgents",
                        },
                      },
                      [
                        _c("a-icon", {
                          attrs: { slot: "checkedChildren", type: "check" },
                          slot: "checkedChildren",
                        }),
                        _vm._v(" "),
                        _c("a-icon", {
                          attrs: { slot: "unCheckedChildren", type: "close" },
                          slot: "unCheckedChildren",
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("message.showOnlineAgents"))),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "route-page-content breadcrumb-content" },
        [
          _c("ChatSidebar", {
            model: {
              value: _vm.tabIndex,
              callback: function ($$v) {
                _vm.tabIndex = $$v
              },
              expression: "tabIndex",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-content-wrapper" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "rounded-0",
                  attrs: {
                    show: _vm.socketConnecting && _vm.user != null,
                    variant: "info",
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.socketConnecting")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.upgrade.enabled && _vm.upgrade.type === "chat-overlay"
                ? _c("UpgradeNeededPageOverlay", {
                    attrs: {
                      plan: _vm.upgrade.plan,
                      feature: _vm.upgrade.feature,
                      name: _vm.upgrade.name,
                    },
                  })
                : _vm.isLiveSupportMenuActivated()
                ? _c("ChatWindowManager", {
                    attrs: {
                      isLive: true,
                      "default-selected-favorite-filter":
                        _vm.getSelectedFavoriteFilter(),
                    },
                  })
                : _vm.tabIndex === "teamChat"
                ? _c("TeamChat", {
                    attrs: { visible: _vm.selectedInbox === "team" },
                  })
                : _vm.tabIndex === "siteVisitors"
                ? _c("VisitorList")
                : _vm.tabIndex === "conversationHistory"
                ? _c("VisitorHistory", {
                    ref: "visitorHistory",
                    attrs: { "time-select": _vm.timeSelect },
                    on: {
                      customTime: _vm.timeChanged,
                      timeSelectChanged: function (val) {
                        return (_vm.timeSelect = val)
                      },
                    },
                  })
                : _vm.tabIndex === "representative"
                ? _c("AgentList", {
                    attrs: {
                      assign: false,
                      "info-button-visible": true,
                      reportButton: true,
                      showOnlineAgents: _vm.showOnlineAgents,
                    },
                  })
                : _vm.tabIndex === "whatsappContacts"
                ? _c("WhatsappContactListSwitcher")
                : _vm.tabIndex === "instagramContacts"
                ? _c("InstagramContactListSwitcher")
                : _vm.tabIndex === "linkedinContacts"
                ? _c("LinkedinContactListSwitcher")
                : _vm.tabIndex === "telegramContacts"
                ? _c("TelegramContactListSwitcher")
                : _vm.tabIndex === "messengerContacts"
                ? _c("MessengerContactListSwitcher")
                : _vm._e(),
              _vm._v(" "),
              _vm.tabIndex === "websiteAnalytics" && _vm.websiteTrackingUrl
                ? _c("iframe", {
                    staticClass: "website-tracking-iframe",
                    attrs: { src: _vm.websiteTrackingUrl },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.tabIndex === "automations"
                ? _c("AutomationList", {
                    attrs: { type: "event", module: "chat" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.tabIndex === "metaLeads" && _vm.metaLeadChannel
                ? _c("LeadList", {
                    attrs: {
                      channel: _vm.metaLeadChannel,
                      "channel-id": _vm.metaLeadChannel._id,
                      "form-mode": false,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }